export default __webpack_public_path__ + "static/media/collage-mentorias.7ca43cfc.png";